module.exports = "/fonts/herculift.woff2?b63812c5d417ed3556eb9243ebd449c7";